<template>
  <div class="columns m-2" >
<!--    <div class="column" style="width: 35%; max-width: 30%">
      <div class="box" style="padding: 8px">
        <trajectory-map ref="trajectoryMap"></trajectory-map>
      </div>
    </div>-->
    <div class="column ml-0 mr-0">
      <div ref="videoRef" class="box" style="padding:8px">
        <div :style="{'height': height - 16 + 'px'}">

          <div class="is-flex is-flex-direction-column" :style="{'height': height - 16 + 'px'}">
            <div class="is-size-6 has-background-light p-1">Event Description</div>
            <div v-if="selectedEvent.textDescription" v-html="selectedEvent.textDescription" class="p-3 my-text"
                 style="overflow: auto"></div>
            <div v-else class="is-flex" :style="{'height': height - 48 + 'px'}">
              <div class="m-auto is-flex is-flex-direction-column">
                <b-icon icon="alert-octagon" class="m-auto">
                </b-icon>
                <div>Description is not available</div>
              </div>
            </div>
          </div>

          <!--          <video :key="videoUrl" autoplay controls
                 :style="{'width': width - 16 + 'px', 'height': height - 16  + 'px' }">
            <source :src="videoUrl" type="video/mp4"/>
          </video>-->
        </div>
      </div>
    </div>
    <div class="column is-one-half">
      <div class="box is-flex is-flex-direction-column" style="padding:8px; height: 100%; max-height: 100%">
        <div class="is-size-6 has-background-light p-1">Update validation</div>
        <b-field expanded class="ml-3 mr-3 mt-5" label="Validation"
                 label-position="on-border">
          <b-select expanded placeholder="Select Validation" size="is-small" required
                    v-model="statusChangeValue">
            <option v-for="key in Object.keys(validationOptions)" :value="key" :key="key">{{ validationOptions[key] }}
            </option>
          </b-select>
        </b-field>
<!--        <b-field expanded class="ml-3 mr-3 mt-3" label="PET"
                 label-position="on-border">
          <b-input expanded placeholder="Set PET value..." size="is-small"
                   v-model="petValue"
                   type="number" step="0.01" required></b-input>
        </b-field>-->
        <b-field expanded class="ml-3 mr-3 mt-5" label="Risk"
                 label-position="on-border">
          <b-select expanded placeholder="Select Risk" size="is-small" required
                    v-model="severityRating">
            <option v-for="key in riskOptions" :value="key" :key="key">{{ key }}
            </option>
          </b-select>
        </b-field>
<!--        <b-field expanded class="ml-3 mr-3 mt-3" label="Risk"
                 label-position="on-border">
          <b-dropdown
              v-model="severityRating"
              expanded
              required
              aria-role="list">
            <template #trigger>
              <b-button expanded size="is-small"
                        icon-right="menu-down">
                Selected ({{ severityRating }})
              </b-button>
            </template>
            <b-dropdown-item v-for="key in riskOptions" :value="key" :key="key" aria-role="listitem">
              <span>{{ key }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </b-field>-->
        <b-button class="mt-auto" @click="onUpdateEvent" type="is-primary" icon-left="content-save" size="is-small">
          Update Event
        </b-button>
      </div>
    </div>
  </div>
</template>


<script>
import {mapGetters} from "vuex";
import {coreIndicatorsOptions, validationOptions} from "@/utils/utils";

export default {
  name: "event-details",
  components: {},
  data() {
    return {
      videoUrl: null,
      statusChangeValue: null,
      petValue: null,
      coreIndicators: [],
      riskOptions:['low','moderate','severe'],
      severityRating: null,
      width: 655, //800
      height: 300, //450
    }
  },
  mounted() {
    this.ratio = this.width / this.height
    console.log('Event id: ', this.eventId)
    window.addEventListener("resize", this.resizeEventHandler);
    this.calculateSizes()
    this.loadData()
  },
  methods: {
    onUpdateEvent() {
      console.log('On update event: ')


      let payload = {
        events: [{
          eventId: this.selectedEvent.id,
          eventValid: this.statusChangeValue,
          updateSnippet: false,
          severityRating: this.severityRating
        }]
      }

      this.$emit('onUpdateConflictEvents', payload)

    },
    calculateSizes() {
      if (this.$refs.videoRef) {
        this.width = Math.round(this.$refs.videoRef.clientWidth)
        this.height = Math.round(this.width / this.ratio)
        if (this.$refs.trajectoryMap) {
          this.$refs.trajectoryMap.setMapHeight(this.height - 16)
        }
      }
    },
    resizeEventHandler(event) {
      console.log('Resize event handler:', event)
      this.calculateSizes()
    },
    loadData() {
      this.isLoading = true

      console.log('Event: ', event)
      this.isLoading = false
      if (this.selectedEvent != null) {
        this.isLoading = true

        this.statusChangeValue = this.selectedEvent.eventValid
        this.petValue = this.selectedEvent.petValue
        this.severityRating = this.selectedEvent.severityRating


        let pathLeadUserPoints = []
        let pathFollowUserPoints = []


        if (this.selectedEvent.fRoadUserPath) {
          if (this.selectedEvent.fRoadUserPath.length > 0) {
            this.selectedEvent.fRoadUserPath.forEach(pathCentroid => {
              if (pathCentroid && pathCentroid.gps_centroid != null && pathCentroid.gps_centroid.length > 0) {
                //get first gps point
                pathFollowUserPoints.push(pathCentroid.gps_centroid)
              }
            })
          }
        }
        if (this.selectedEvent.lRoadUserPath) {
          if (this.selectedEvent.lRoadUserPath.length > 0) {
            this.selectedEvent.lRoadUserPath.forEach(pathCentroid => {
              if (pathCentroid && pathCentroid.gps_centroid != null && pathCentroid.gps_centroid.length > 0) {
                //get first gps point
                pathLeadUserPoints.push(pathCentroid.gps_centroid)
              }
            })
          }
        }

        /*        let response = await this.startVideoDownload(event.videoBlurredSnippetMetadataId)
        this.videoUrl = response.url

        this.files = [
          {
            url: this.videoUrl,
            name: 'name_1.mp4'
          },
          {
            url: this.videoUrl,
            name: 'name_2.mp4'
          },
          {
            url: this.videoUrl,
            name: 'name_3.mp4'
          }
        ]*/

        if (this.$refs.trajectoryMap) {
          setTimeout(() => {
            this.$refs.trajectoryMap.loadPath(pathLeadUserPoints, pathFollowUserPoints)
          }, 1000)
        }

        this.isLoading = false
        console.log('Video url: ', this.videoUrl)
      }
    }
  },
  computed: {
    coreIndicatorsOptions() {
      return coreIndicatorsOptions
    },
    validationOptions() {
      return validationOptions
    },
    ...mapGetters({
      selectedEvent: 'dataValidationModule/getSelectedEvent',
    })
  },
  watch: {
    selectedEvent() {
      this.loadData()
    }
  }
}
</script>

<style>

.my-text h2 {
  font-size: 1.5em !important;
}

</style>